import { environment } from '../../../../../environments/environment'
import * as moment_ from 'moment'
import { MatDatepickerInputEvent } from '@angular/material/datepicker'

import { Component, OnInit } from '@angular/core'
import { CoordinatesOperationServiceScheduler, ListOperationServiceSchedule } from '../../../../../app/models/OperationService'
import { UserAdmin } from '../../../../../app/models/UserAdmin'
import { OperatorListScheduler } from '../../../../../app/models/RankingEvaluator'
import { NotificationService } from '../../../../../app/services/notification.service'
import { Router } from '@angular/router'
import { OperationServiceService } from '../../../../../app/services/operation.service.service'

import { CompanyService } from '../../../../../app/services/company.service'
import { ViewValidation } from '../../../../_helpers/ViewValidation'
import { getHasMultipleCompanyProviders, getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { CoordinatesPlantingOpportunity } from 'src/app/models/Planting'
import { Region } from 'src/app/models/Region'
import { RegionsService } from 'src/app/services/regions.service'

@Component({
	selector: 'app-operator-scheduling',
	templateUrl: './operator-scheduling.component.html'
})
export class OperatorSchedulingComponent implements OnInit {

	public ViewValidation: ViewValidation = new ViewValidation()
	public companyId: string
	public sessionUser: UserAdmin = getLoggedUser()
	public allRegions: Array<Region> = []

	public myMap: google.maps.Map
		public polygonsDelimitAllRegions: Array<google.maps.Polygon> = []
	public regionInfoWindow = new google.maps.InfoWindow()

	public addressesOperations: Array<{lat: number, lng: number}> = []
	public operationsIds: Array<string> = []
	public operationsSchedule: CoordinatesOperationServiceScheduler = new CoordinatesOperationServiceScheduler()
	public operationSelectedAgroup: CoordinatesPlantingOpportunity
	public operators: Array<OperatorListScheduler> = []
	public operatorSelected: OperatorListScheduler = new OperatorListScheduler()
	public current_day: string = ''
	public current_day_now: string = moment_().format('YYYY-MM-DD 00:00:00.000')
	public date: Date = new Date()

	public openAgrupar: boolean = false
	public companyIsActive: boolean = false
	public isAdmin: boolean = false
	public enableButton: boolean = false
		public viewAllRegionsInMap: boolean = true
	public hasMultipleCompanyProviders: boolean = getHasMultipleCompanyProviders()

	constructor(
		private router: Router,
		public notificationService: NotificationService,
		private operationServiceService: OperationServiceService,
		private companyService: CompanyService,
		private readonly regionsService: RegionsService
	) {}

	public async ngOnInit(): Promise<void> {
		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))

		this.companyId = localStorage.getItem('companyId')

		const cameFromMapSchedule = Boolean(localStorage.getItem('cameFromScheduleMap') == 'true')

		if (cameFromMapSchedule) {
			const operationsServiceIds: Array<string> = JSON.parse(localStorage.getItem('operationService'))
			this.operationServiceService.getAddresses(operationsServiceIds).subscribe(addresses => {
				localStorage.setItem('baseCoordinatesOperation', JSON.stringify(addresses))
				console.log('addresses', addresses)
				this.addressesOperations = addresses

				this.startup()
			})
		} else {
			this.addressesOperations = JSON.parse(localStorage.getItem('baseCoordinatesOperation'))
			this.startup()
		}
	}

	private async startup() {
		const operationsIds = localStorage.getItem('operationService')

		let hasCreatePermission: boolean = false

		if (operationsIds) {
			this.operationsIds = JSON.parse(operationsIds)
			hasCreatePermission = Boolean(this.sessionUser.assignments.includes('OPERATION_SERVICE_SCHEDULE_CREATE'))
		}

		this.enableButton = Boolean(hasCreatePermission || this.isAdmin)

		if (this.operationsIds.length == 0) {
			this.notificationService.notify('Manejo não encontrado', 420)
			localStorage.removeItem('operationService')
			localStorage.removeItem('baseCoordinatesOperation')
			localStorage.removeItem('cameFromScheduleMap')
			this.router.navigate(['/panel/OperationService'])
		}

		await this.checkCompanyStatus()
		await this.fetchRegions()
		await this.openTabTwo()
		await this.getCoordinatesOperationScheduler()
		this.initMap()

		if (this.allRegions.length > 0) {
						this.insertShowRegionsButtonInGooleMaps()
						this.createAllRegions()
						this.showAllRegionsInMap()
				}
	}

	public async checkCompanyStatus(): Promise<void> {
		try {
			const companyStatus: string = await this.companyService
				.checkStatus(this.companyId)
				.toPromise()
			if (companyStatus === 'ACTIVE') {
				this.companyIsActive = true

				return
			}
			this.companyIsActive = false
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public async openTabTwo(date?: any): Promise<void> {
		if (date) {
			this.current_day = date
		} else {
			this.current_day = moment_().format('YYYY-MM-DD 08:00:00.000')
		}

		await this.getOperators()
	}

	public async getCoordinatesOperationScheduler(): Promise<void> {
		this.operationsSchedule =
			await this.operationServiceService.getCoordinatesOperationScheduler(this.companyId).toPromise()
	}

	public initMap(): void {
		const mapView: HTMLDivElement = document.getElementById('map-secundario') as HTMLDivElement

		let latOp: number = 0
		let lngOp: number = 0

		try {
			if (this.addressesOperations[0].lat) {
				latOp = this.addressesOperations[0].lat
			}
			if (this.addressesOperations[0].lng) {
				lngOp = this.addressesOperations[0].lng
			}
		} catch (error) {
			console.log(
				'Erro ao encontrar localização da operação selecionada',
				error
			)
		}

		const map: google.maps.Map = new google.maps.Map(mapView, {
			zoom: 15,
			center: new google.maps.LatLng(latOp, lngOp)
		})

		map.setOptions({
			styles: [
				{
					featureType: 'poi',
					stylers: [
						{ visibility: 'off' }
					]
				},
				{
					featureType: 'transit.station.bus',
					stylers: [
						{ visibility: 'off' }
					]
				}
			]
		})

		const iconBase: string = 'assets/images/'

		const iconsLabel: any = {
			agendamento: {
				icon: `${iconBase}m1.svg`,
				name: 'MANEJO EM AGENDAMENTO'
			},
			agendado: {
				icon: `${iconBase}m2.svg`,
				name: 'MANEJO AGENDADO'
			},
			realizado: {
				icon: `${iconBase}m3.svg`,
				name: 'MANEJO REALIZADO'
			}
		}

	 const hasLegend = document.getElementById('evaluator-infos')
		hasLegend.innerHTML = ''

	 if (!hasLegend) {
						const newDiv = document.createElement('div')
						newDiv.setAttribute('class', 'evaluator-infos')
						document.getElementsByClassName('maps')[0].appendChild(newDiv)
				}

	 const legend = hasLegend

	 for (const key in iconsLabel) {
						const type = iconsLabel[key]
						const name = type.name
						const icon = type.icon

						const div = document.createElement('div')
						div.setAttribute('class', 'item')
						div.innerHTML = `<img class="pin" src="${icon}"> <p class="pin-text">${name}</p>`
						legend.appendChild(div)

				}
				// map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend)
		const features: any = []

		// OPERATIONS
		if (this.operationsSchedule.operationCompleted.length > 0) {

			this.operationsSchedule.operationCompleted.forEach(operationObj => {
				try {
					features.push({
						position: new google.maps.LatLng(
							operationObj.lat,
							operationObj.lng
						),
						type: 'realizado'
					})
				} catch (error) {
					console.log(
						'Erro ao encontrar localização da operação',
						operationObj.idMongo,
						error
					)
				}
			})
		}

		if (this.operationsSchedule.operationScheduler.length > 0) {

			this.operationsSchedule.operationScheduler.forEach(operationObj => {
				try {
					features.push({
						position: new google.maps.LatLng(
							operationObj.lat,
							operationObj.lng
						),
						type: 'agendado',
						operator: operationObj.operator,
						operatorId: operationObj.operatorId,
						scheduling: operationObj.schedulingDate,
						idMongo: operationObj.idMongo
					})
				} catch (error) {
					console.log(
						'Erro ao encontrar localização da operação',
						operationObj.idMongo,
						error
					)
				}
			})
		}

		// SELECTED DEMAND
		for (const data of this.addressesOperations) {
			features.push({
				position: new google.maps.LatLng(
					data.lat,
					data.lng
				),
				type: 'agendamento'
			})
		}

		// Seting Markers
		features.forEach(feature => {
			const icons: any = {
				agendamento: {
					icon: {
						url: `${iconBase}m1.png`,
						origin: new google.maps.Point(0, 0),
						labelOrigin: new google.maps.Point(21, 19)
					},
					name: 'MANEJO EM AGENDAMENTO'
				},
				agendado: {
					icon: {
						url: `${iconBase}m2.png`,
						origin: new google.maps.Point(0, 0),
						labelOrigin: new google.maps.Point(21, 19)
					},
					name: 'MANEJO AGENDADO'
				},
				realizado: {
					icon: {
						url: `${iconBase}m3.png`,
						origin: new google.maps.Point(0, 0),
						labelOrigin: new google.maps.Point(21, 19)
					},
					name: 'MANEJO REALIZADO'
				}
			}

			const label: google.maps.MarkerLabel = {
				fontWeight: 'bold',
				fontSize: '14px',
				color: 'white',
				text: icons[feature.type].count || ' '
			}

			const marker: google.maps.Marker = new google.maps.Marker({
				position: feature.position,
				icon: icons[feature.type].icon,
				animation: google.maps.Animation.DROP,
				label,
				map
			})

			const initDay = new Date().setHours(0, 0, 0, 0)

			const dateIsValid: boolean = Boolean(
				new Date(feature.scheduling) >= new Date(initDay)
			)

			let operatorIsValid: boolean = false

			this.operators.forEach(operator => {
				if (operator.idMongo == feature.operatorId) {
					operatorIsValid = true
				}
			})

			const enableButtonGroup = Boolean(dateIsValid && operatorIsValid)

			if (feature.type === 'agendado') {
				// Adicionar evento no botão
				const content = `<div style="display: flex;
											flex-direction: column;
											width: 100%;
											height: 100px;
											justify-content: space-between;"
								 >
									<p>
										<span style="font-weight: bolder;
													 color: #6f9752;"
										>
											Operador:
										</span>
										${feature.operator}
									</p>
									<p>
										<span style="font-weight: bolder;
													 color: #6f9752;"
										>
											Data:
										</span>
										${moment_(feature.scheduling).format('DD/MM/YYYY')}
									</p>
									<button class="${enableButtonGroup ? 'btn-primary' : 'btn-disabled'}" id="agroupButton">Agrupar</button>
								</div>`

				const infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow(
					{
						content
					}
				)

				const functionGroup = () => {
					this.openModalAgrupar(feature.idMongo)
				}

				google.maps.event.addListener(marker, 'click', function(e) {

					infoWindow.open(map, this)

					if (enableButtonGroup) {
						setTimeout(() => {
							const buttonAgroup = document.getElementById('agroupButton')

							buttonAgroup.addEventListener('click', () => {
								functionGroup()
							})
						}, 0)
					}
				})

				google.maps.event.addListener(map, 'click', function(e) {
					infoWindow.close()
				})
			}
		})

		map.addListener('click', () => {
						this.regionInfoWindow.close()
				})

		this.myMap = map
	}

	public async getOperators(): Promise<void> {
		const latitude: number = this.addressesOperations[0].lat || null
		const longitude: number = this.addressesOperations[0].lng || null

		try {
			const response: any = await this.operationServiceService.listOperatorForSchedulingDate({
				companyId: this.companyId,
				date: this.current_day,
				lat: latitude,
				lng: longitude
			}).toPromise()

			this.operators = response

			if (this.operatorSelected) {
				this.operators.map(operator => {
					if (operator.idMongo == this.operatorSelected.idMongo) {
						operator.checked = true
					} else {
						operator.checked = false
					}
				})
			}
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public async selectOperator(operator: OperatorListScheduler): Promise<void> {
		this.operatorSelected = operator

		this.operators.forEach(operator => {
			if (operator.idMongo === this.operatorSelected.idMongo) {
				operator.checked = true
			} else {
				operator.checked = false
			}
		})
	}

	public changeDate(event: MatDatepickerInputEvent<Date>) {
		try {
			const date = moment_(event.value).format('YYYY-MM-DD 08:00:00.000')
			this.current_day = date
			this.openTabTwo(this.current_day)
		} catch (error) {
			this.current_day = ''
		}
	}

	public async goScheduler(): Promise<void> {
		this.router.navigate(['/panel/operation/pre-schedule'])
	}

	public async scheduleOperation(): Promise<void> {
		try {
			const operationsScheduler: Array<string> = []

			this.operationsIds.forEach(idMongo => {
				operationsScheduler.push(idMongo)
			})

			const response: { message: string } = await this.operationServiceService.assignOperatorToOperation(
					operationsScheduler,
					this.operatorSelected.idMongo,
					this.current_day,
					this.sessionUser._id
				).toPromise()

			this.notificationService.notify(response.message, 200)

			localStorage.removeItem('operationService')
			localStorage.removeItem('baseCoordinatesOperation')

			this.router.navigate(['/panel/management/operationService'])

		} catch (err) {
			console.log(err)
		}
	}

	public openModalAgrupar(operationId: string): void {
		this.operationsSchedule.operationScheduler.forEach(operation => {
			if (operation.idMongo == operationId) {
				this.operationSelectedAgroup = {...operation, schedulingDate: moment_(operation.schedulingDate).format('DD/MM/YYYY')}
			}
		})
		this.openAgrupar = true
	}

	public closeModalAgrupar() {
		this.openAgrupar = false
	}

	public groupOperation() {
		this.current_day = moment_(this.operationSelectedAgroup.schedulingDate).format('YYYY-MM-DD 08:00:00.000')
		this.operatorSelected.idMongo = this.operationSelectedAgroup.operatorId

		this.scheduleOperation()
	}

	public async fetchRegions() {
		try {
			this.allRegions =
				await this.regionsService.getRegionsFromMapByCompanyId(this.companyId).toPromise()
		} catch (err) { }
	}

	public insertShowRegionsButtonInGooleMaps() {
				const iconBase: string = 'assets/images/icon/hide-icon.svg'
		  const svgIcon = document.createElement('img')
				svgIcon.setAttribute('id', 'img-show-all-regions')
		  svgIcon.setAttribute('src', iconBase)

		  const button = document.createElement('button')

				const handleClickButton = () => {
						this.viewAllRegionsInMap = !this.viewAllRegionsInMap
			   this.switchShowHideRegionsInMap()
						this.updateImageButtonShowHideRegions()
		}

		  button.setAttribute('class', 'btn-google-maps regions-button')
		  button.appendChild(svgIcon)

		  button.addEventListener('click', () => {
			handleClickButton()
		})

		  this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(button)
		}

	public createAllRegions() {
				this.allRegions.forEach(region => {
			const polygon = new google.maps.Polygon({
				strokeOpacity: 0.6,
				strokeWeight: 2,
				fillColor: region.color,
				fillOpacity: 0.5,
				paths: region.coordinates
			})

			polygon.addListener('click', event => {
				const clickLatLng = event.latLng

				if (!this.regionInfoWindow) {
					this.regionInfoWindow = new google.maps.InfoWindow()
				}

				this.regionInfoWindow.setContent(region.name)
				this.regionInfoWindow.setPosition(clickLatLng)
				this.regionInfoWindow.open(this.myMap)
			})

			this.polygonsDelimitAllRegions.push(polygon)
				})
		}

	public switchShowHideRegionsInMap() {
				if (this.viewAllRegionsInMap) {
						this.showAllRegionsInMap()
				} else {
						this.hideAllRegionsInMap()
				}
		}

		public showAllRegionsInMap() {
				this.polygonsDelimitAllRegions.forEach(poligon => {
						poligon.setMap(this.myMap)
				})
		}

		public hideAllRegionsInMap() {
				this.polygonsDelimitAllRegions.forEach(poligon => {
						poligon.setMap(null)
				})

		  this.regionInfoWindow.close()
		}

	public updateImageButtonShowHideRegions() {
				const iconBase: string =
						`assets/images/icon/${this.viewAllRegionsInMap ? 'hide-icon' : 'show-icon'}.svg`

				const imageButton: HTMLImageElement =
						document.getElementById('img-show-all-regions') as HTMLImageElement

				if (imageButton) {
						imageButton.setAttribute('src', iconBase)
				}
		}

	public hiddenModalMultipleCompanyProviders() {
		this.hasMultipleCompanyProviders = false
	}
}
